document.addEventListener('turbolinks:load', function() {
  $('input[name="organization[offers_birthday_promo]"]').bind('change', function(){
    // Show when radio is true, hide when radio is false
    var showOrHide = $(this).val()
    $('#birthday-fields').toggle(showOrHide);
  });
});
